import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"

import { Layout, SEO } from "src/components/common"

import { useMeta } from "src/utils"

export default props => {
  const { privacyPolicy } = useStaticQuery(QUERY)
  const file = privacyPolicy.sections[0].components[0].file.file
  const meta = useMeta({ ...privacyPolicy })

  return (
    <Layout pageContext={props.pageContext}>
      <SEO {...meta} />
      <Privacy>
        <iframe
          title="privacy-policy"
          src={file.url}
          height="100%"
          width="100%"
          frameborder="0"
        ></iframe>
      </Privacy>
    </Layout>
  )
}

const Privacy = styled.main`
  height: 100vh;
  overflow: hidden;
`

const QUERY = graphql`
  {
    privacyPolicy: contentfulPage(pageId: { eq: "privacy-policy" }) {
      ...Page
    }
  }
`
